export default "__VITE_ASSET__4798bd92__"